import {withStyles} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import MenuItem from '@material-ui/core/MenuItem';
import {getDirectionStyles} from '../../../utils/ThemeUtils';

export const StyledPopover = withStyles(theme => ({
    root: {
        marginTop: '1px'
    },
    paper: {
        minWidth: 196,
        maxWidth: '100%',
        width: `calc(100% - ${theme.spacing(8)}px)`,

        [theme.breakpoints.up('fsm')]: {
            width: `calc(100% - ${theme.spacing(24)}px)`
        },

        [theme.breakpoints.up('fmd')]: {
            width: 196
        },

        [theme.breakpoints.up('flg')]: {
            width: 266
        }
    }
}))(Popover);

export const LoaderPopover = withStyles(theme => ({
    paper: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(4),
        // @ts-ignore
        backgroundColor: theme.palette.background.overlays,

        '& > div': {
            marginRight: theme.spacing(4)
        }
    }
}))(Popover);

export const ErrorPopover = withStyles(theme => ({
    paper: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2, 2, 2, 4),
        // @ts-ignore
        backgroundColor: theme.palette.error.main,

        '& > p': {
            margin: theme.spacing(0, 6, 0, 4)
        }
    }
}))(Popover);

export const StyledListItem = withStyles(theme => ({
    root: {
        marginTop: '1px',

        padding: theme.spacing(4, 3),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.primary,
        fontSize: theme.typography.caption.fontSize,
        textTransform: 'uppercase',
        fontWeight: 'bold',

        '&:hover': {
            backgroundColor: `${theme.palette.primary.light}!important`
        },
        '& > div > svg': {
            marginLeft: 'auto'
        },
        '& > svg': {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 0, 0, 'auto'),
                theme.spacing(0, 'auto', 0, 0)
            ),
            fontSize: '1.6rem'
        }
    }
}))(MenuItem);

export const StyledButton = withStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexGrow: 1,
        width: '100%',
        height: 67,
        fontSize: theme.typography.body1.fontSize,

        marginTop: theme.spacing(11),
        padding: theme.spacing(0, 3),

        [theme.breakpoints.up('fsm')]: {
            marginTop: theme.spacing(6)
        },

        [theme.breakpoints.up('fmd')]: {
            marginTop: theme.spacing(5),
            minWidth: 196,
            width: 196
        },

        [theme.breakpoints.up('flg')]: {
            minWidth: 266,
            width: 266
        },

        "& [class*='MuiButton-endIcon']": {
            marginLeft: getDirectionStyles(theme.direction)('inherit', 0)
        },

        // Expand icon
        '& svg:last-of-type': {
            fontSize: '1.2rem'
        }
    }
}))(Button);

export const StyledInfoIconWrapper = withStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0, 0, 0, 2),
            theme.spacing(0, 2, 0, 0)
        )
    }
}))(Box);
